/* ==========================================================================
   Design System
   Notifications Styling
   ========================================================================== */
/* ==========================================================================
   Design System
   Variables
   ========================================================================== */
/* ==========================================================================
   Design System
   Breakpoint variables.

   NOTE: If any of the values in this file are adjusted,
         they need to be adjusted in vars-breakpoints.js as well.
   ========================================================================== */
/* ==========================================================================
   Design System
   Grid mixins
   ========================================================================== */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* ==========================================================================
   Design System
   Media queries
   ========================================================================== */
/* ==========================================================================
   Design System
   Base styles
   ========================================================================== */
/* ==========================================================================
   Design System
   Utilities
   ========================================================================== */
.no-js .u-js-only {
  display: none !important;
}

.u-hide-if-js {
  display: none !important;
}
.no-js .u-hide-if-js {
  display: block !important;
}

.u-clearfix::after {
  content: "";
  display: table;
  clear: both;
}

.u-visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  border: 0;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
}

@media only all and (max-width: 37.5em) {
  .u-hide-on-mobile {
    display: none;
  }
}

.u-show-on-mobile {
  display: none;
}
@media only all and (max-width: 37.5em) {
  .u-show-on-mobile {
    display: block;
  }
}

.u-hidden {
  display: none !important;
}

.u-invisible {
  visibility: hidden;
}

.u-inline-block {
  display: inline-block;
}

.u-right {
  float: right;
}

.u-break-word {
  word-break: break-all;
}

.u-nowrap {
  white-space: nowrap;
}

/* stylelint-disable selector-class-pattern */
.u-flexible-container {
  /* stylelint-enable */
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
}
.u-flexible-container__inner {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.u-flexible-container--4-3 {
  /* stylelint-enable */
  position: relative;
  padding-bottom: 75%;
  height: 0;
}

/* stylelint-disable selector-class-pattern */
/* stylelint-enable */
.u-mt0 {
  margin-top: 0 !important;
}

.u-mb0 {
  margin-bottom: 0 !important;
}

.u-mt5 {
  margin-top: 5px !important;
}

.u-mb5 {
  margin-bottom: 5px !important;
}

.u-mt10 {
  margin-top: 10px !important;
}

.u-mb10 {
  margin-bottom: 10px !important;
}

.u-mt15 {
  margin-top: 15px !important;
}

.u-mb15 {
  margin-bottom: 15px !important;
}

.u-mt20 {
  margin-top: 20px !important;
}

.u-mb20 {
  margin-bottom: 20px !important;
}

.u-mt30 {
  margin-top: 30px !important;
}

.u-mb30 {
  margin-bottom: 30px !important;
}

.u-mt45 {
  margin-top: 45px !important;
}

.u-mb45 {
  margin-bottom: 45px !important;
}

.u-mt60 {
  margin-top: 60px !important;
}

.u-mb60 {
  margin-bottom: 60px !important;
}

.u-w100pct {
  width: 100%;
}

.u-w90pct {
  width: 90%;
}

.u-w80pct {
  width: 80%;
}

.u-w70pct {
  width: 70%;
}

.u-w60pct {
  width: 60%;
}

.u-w50pct {
  width: 50%;
}

.u-w40pct {
  width: 40%;
}

.u-w30pct {
  width: 30%;
}

.u-w20pct {
  width: 20%;
}

.u-w10pct {
  width: 10%;
}

.u-w75pct {
  width: 75%;
}

.u-w25pct {
  width: 25%;
}

.u-w66pct {
  width: 66.6666666667%;
}

.u-w33pct {
  width: 33.3333333333%;
}

/* stylelint-disable selector-class-pattern */
small,
.u-small-text {
  /* stylelint-enable */
  font-size: 0.875em;
}

/* ==========================================================================
   Utility classes for transitions.

   Adds transitions utilty classes for transform, opacity,
   and for the removing the transition duration.
   ========================================================================== */
.u-no-animation {
  transition-duration: 0s !important;
}

.u-move-transition {
  transition: transform 0.25s ease-out;
}

.u-move-to-origin {
  transform: translate3d(0, 0, 0);
}

.u-move-left {
  transform: translate3d(-100%, 0, 0);
}

.u-move-left-2x {
  transform: translate3d(-200%, 0, 0);
}

.u-move-left-3x {
  transform: translate3d(-300%, 0, 0);
}

.u-move-right {
  transform: translate3d(100%, 0, 0);
}

.u-move-up {
  transform: translate3d(0, -100%, 0);
}

.u-alpha-transition {
  transition: opacity 0.25s linear;
}

.u-alpha-100 {
  opacity: 1;
}

.u-alpha-0 {
  opacity: 0;
}

.u-max-height-transition {
  overflow: hidden;
  contain: paint;
  transition: max-height 0.2s ease-out;
}

/*
.u-max-height-default {
  This class is kept for documentation completeness.
  The actual max-height is set in the JavaScript,
  so that we know what the actual height of the content is for easing purposes.
}
*/
.u-max-height-zero {
  max-height: 0 !important;
}

.u-max-height-summary {
  /* The value set here should show 4 lines of text at our standard 16px
     base font size. The calculation comes from the following:
     88px = 16 * 5.5em.
     5.5em = base-line-height (22px) * 4 / base-font-size (16px)
  */
  max-height: 88px !important;
}

.o-banner {
  padding: 0.9375em 0;
  background: var(--gold-10);
  border-bottom: 1px solid var(--gray-40);
  font-size: 0.875em;
}
.o-banner .m-notification {
  border: none;
  padding: 0;
}
.o-banner .m-notification__icon {
  left: 0;
  top: 0;
}
.o-banner--dark {
  background: var(--teal-dark);
  border-color: var(--teal-dark);
  color: var(--white);
}
.o-banner--dark .m-notification {
  background: var(--teal-dark);
}
.o-banner--dark .m-notification .cf-icon-svg {
  fill: var(--white);
}
.o-banner--dark .m-notification a {
  color: var(--white);
  border-color: var(--white);
}
.o-banner--dark .m-notification a:visited, .o-banner--dark .m-notification a.visited {
  border-color: var(--teal-40);
  color: var(--teal-40);
}
.o-banner--dark .m-notification a:hover, .o-banner--dark .m-notification a.hover {
  border-color: var(--gray-15);
  color: var(--gray-15);
}
.o-banner--dark .m-notification a:focus, .o-banner--dark .m-notification a.focus {
  border-color: var(--white);
  color: var(--white);
}
.o-banner--dark .m-notification a:active, .o-banner--dark .m-notification a.active {
  border-color: var(--gray-15);
  color: var(--gray-15);
}
@media only all and (min-width: 37.5625em) {
  .o-banner {
    font-size: 1em;
  }
}